import type { CharacterConfig } from "../types";

/**
 * Barbarian - High HP, aggressive playstyle
 *
 * Base stats: 36 HP (+20% vs Warrior), 6 ATK, 2 Armor
 * Starting skill: Slash Lv1 (high risk, high reward)
 * Visual: Uses barbarian sprite (to be created in Phase 5)
 */
export const barbarianConfig: CharacterConfig = {
  id: "barbarian",
  name: "Barbarian",
  description: "A fierce warrior with high HP and devastating slash attacks.",
  sprite: "barbarian",
  stats: {
    maxHp: 36,
    atk: 6,
    armor: 2,
  },
  startingSkills: {
    slash: 1,
  },
};
